import SplashScreen from '@components/SplashScreen';
import { useBackHandlerContext } from '@context/BackHandler';
import { useInitializeContext } from '@context/Initialize';
import { useMainContext } from '@context/Main';
import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { useEffect, useLayoutEffect } from 'react';

import Navigation from '../../../components/Navigation';
import Banner from '@pages/Main/MainView/components/Banner';
import LogoContainer from './components/LogoContainer';
import UntactDepartmentList from './components/UntactDepartmentList';

import * as styles from './styles';
import { useNavigate } from 'react-router-dom';
import { EXIT } from '@router/path';

const MainView = () => {
  const { setFirstUntactDepartmentListItem } = useMainContext();
  const { focusKey } = useFocusable();
  const { addCallback } = useBackHandlerContext();
  const navigate = useNavigate();

  useLayoutEffect(() => {
    return addCallback(() => {
      navigate(EXIT);
      return false;
    });
  }, [focusKey, addCallback, navigate]);

  const { isInitialized } = useInitializeContext();

  useEffect(() => {
    if (isInitialized) {
      setFirstUntactDepartmentListItem();
    }
  }, [isInitialized, setFirstUntactDepartmentListItem]);

  return (
    <FocusContext.Provider value={focusKey}>
      {!isInitialized && <SplashScreen />}
      <div css={isInitialized ? styles.mainContainer : styles.unInitialized}>
        <section css={styles.navContainer}>
          <Navigation />
        </section>

        <section css={styles.contentContainer}>
          <LogoContainer />
          <Banner />
          <UntactDepartmentList />
        </section>
      </div>
    </FocusContext.Provider>
  );
};

export default MainView;
